import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://online-market-api-eight.vercel.app/api/',
  // baseURL: 'http://localhost:3001/api',
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default axiosInstance;
